import './index.sass';
import './inputEmoji';
import {messagesAction} from './messages-actions'
import {initSliders} from './dialog-slider/';
import 'malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min';
import autosize from "autosize";
import axios from "axios";
import throttle from 'lodash-es/throttle'

export default () => {
  const initScrollList = () => {
    const $list = $('.messages-list');
    if($list.length) {
      $list.scrollTop($list[0].scrollHeight);
    }
  }
  initScrollList();

  autosize($('.comment-textarea')).on('autosize:resized', function(){
    initScrollList();
  });
  messagesAction();
  initSliders();
  let isMobile = false;

  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  } else {
    isMobile = false;
  }
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf("android") > -1;

  if(isAndroid) {
    $('.messages-section').addClass('messages-section--android')
  }

  $(document).on('click', '.js-attach-image', function(){
    $(this).closest('form').find('.js-file-input').trigger('click');
    // return false;
  });
  let page = 2;
  let isLoad = true;
  const loader = `<div class="user-list__loader"><div class="list-loader"></div></div>`;
  const listItems = $('.user-list');
  const state = $('.js-select-messages').val() === 'incoming' ? '' : $('.js-select-messages').val();
  const input = $('.js-search-input');
  let q;

  function initAxios(search) {
    const url = '/api/messages';
    if(!$('.user-list__loader').length) {
      listItems.append(loader);
    }
    axios({
      method: 'GET',
      url: url,
      params: {
        page,
        q,
        state
      }
    }).then(response => {
      const $loader = $('.user-list__loader');
      if(!search) {
        page = response.data.page
        listItems.append(response.data.items)
        isLoad = true;
      } else {
        page = response.data.page
        listItems.append(response.data.items)
      }
      $loader.remove();
      initSliders();
      if(response.data.page === 0) {
        isLoad = false;
        $loader.remove();
      }
    })
  }

  function initSearch() {
    input.on('input', throttle(function() {
      const val = $(this).val();
      if(val.length > 3) {
        page = 0;
        page++;
        q = val;
        listItems.find('.user-item').remove();
        initAxios(true)
      } else if(val.length === 0) {
        page = 1
        q = '';
        listItems.find('.user-item').remove();
        initAxios(false)
      }
    },500))
  }

  function initScroll() {
    $('.js-scroll-list').on('scroll', throttle(function () {
      let div = $(this).get(0);
      if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
        if(isLoad) {
          isLoad = false;
          initAxios(false)
        }
      }
    },500));
  }
  initScroll();
  initSearch();

  function preloadingOverlayShow() {
    $('#page').addClass('__preloading-overlay');
  }
  function preloadingOverlayHide() {
    $('#page').removeClass('__preloading-overlay');
  }

  function initPhotoFileUpload(form_selector) {
    var $form = form_selector,
      url = $form.data('photo-url');
    $form.find('#message-file-input').fileupload({
      url: url,
      dropZone: null,
      type: 'POST',
      headers: {
        "X-CSRF-Token": $('meta[name=csrf-token]').attr('content'),
      },
      formData: {},
      singleFileUploads: false,
      multipart: true,
      start: function () {
        preloadingOverlayShow();
      },
      done: function (e, data) {
        console.log('done')
        if (data.result.errors) {
          preloadingOverlayHide();
          alert(data.result.errors);
          return;
        }

        var $ImagesList = $form.find('.attach-block');
        $ImagesList.append(data.result.photos);
        $ImagesList.parent().show();
        $('.message-form__button').removeClass('disabled').removeAttr('disabled')
        preloadingOverlayHide();
      },
      fail: function () {
        preloadingOverlayHide();
      }
    });
  }

  $(document).on('click', '.js-remove-message-photo', function () {
    $(this).parent().remove();
    return false;
  });
  initPhotoFileUpload($('.js-send-message-form'))

  // смайлики. Оригинал файла редактировал, что б к нашей кнопке припаять открытие смайлов
  $('.message-input').emoji();
  $('window').resize(function () {
    if (window.innerWidth > 767) {
      $('.messages-body').css('display', 'flex');
      if ($('.messages-body').css('display') === 'none') {
        $('.messages-body').css('display', 'flex');
      }
      if ($('.messages-aside').css('display') === 'none') {
        $('.messages-aside').css('display', 'flex');
      }
    } else if ($('.messages-body').css('display') === 'flex') {
      $('.messages-aside').css('display', 'flex');
      $('.messages-body').css('display', 'none');
    }
  })
  $('body').on('click', '.messages-body__arrow', function() {
    $('.messages-aside').css('display', 'flex');
    $('.messages-body').css('display', 'none');
    return false;
  });

  $('#new-dialog-message-form').on('ajax:success', function(e) {
    const data = e.detail[0]
    if (data.error) {
      showError(data.error);
      return false;
    }
    if (data.dateBreakpoint) {
      $('.messages-list').append(data.dateBreakpoint);
    }
    $('.messages-list').append(data.message).imagesLoaded(function() {
      initScrollList();
    });
    $(this).find('textarea').val('');
    $('.attach-block').empty();
    $(this).find(':submit').addClass('disabled').attr('disabled', 'disabled');
    return false;
  });
}
